import { friendsQueryOptions } from '@/hooks/contacts/use-friends';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function createGroupLoader() {
  return {
    promises: queryClient.prefetchQuery(friendsQueryOptions).catch(catchFetcherError),
  };
}
